<template>
  <section class="page-section" :class="className">
    <BaseContainer>
      <h3 class="page-section__heading" v-if="title">
        <TextHeading>{{ title }}</TextHeading>
        <span v-if="subtitle" class="page-section__heading-intro">{{ subtitle }}</span>
      </h3>
      <slot></slot>
    </BaseContainer>
  </section>
</template>

<script>
import TextHeading from './TextHeading.vue'
import BaseContainer from './BaseContainer.vue'
export default {
  name: 'PageSection',
  components: {
    BaseContainer,
    TextHeading
  },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    halfTint: {
      type: Boolean,
      default: false
    },
    gradient: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `${(this.gradient && 'page-section--gradient') || ''} ${(this
        .halfTint &&
        'page-section--half-tint') ||
        ''}`
    }
  }
}
</script>

<style lang="postcss">
.page-section {
  @apply mt-8 mb-12;
}
.page-section__heading {
  @apply mb-4;
}
.page-section__heading-intro {
  @apply pt-2 block text-lg;
}
.page.modal .page-section {
  @apply mt-0;
}
.page-section--gradient {
  @apply bg-gradient-tl-primary pt-10 pb-6;
}
.page-section--gradient .page-section__heading {
  @apply text-white;
}
.page-section--half-tint {
  background-image: linear-gradient(#e6ebe9 40%, white 0%);
}
@screen md {
  .page-section {
    @apply mt-16 mb-24;
  }
  .page-section--gradient {
    @apply pt-20 pb-20;
  }
  .page-section__heading {
    @apply mb-6;
  }
}
</style>

